// api
import type {
  GetDeviceApiResponse,
  GetDeviceOptionalFields,
  GetDevicesApiResponse,
  PostMbusDeviceApiArg,
  PostMbusDeviceApiResponse,
} from '@/api/generated/recalc/endpoints/v2/devices';

// relative
import { apiSliceV2Generated as api } from '../../apiSlice';

export const devicesApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getDevicesByAccount: builder.query<
      GetDevicesApiResponse,
      {
        accountId: number;
        includeFields?: GetDeviceOptionalFields[];
      }
    >({
      query: ({ accountId, includeFields }) => ({
        url: '/v2/Devices',
        params: {
          AccountIds: [accountId],
          OrderBy: 'deviceId',
          OrderDirection: 'asc',
          Top: 10000,
          IncludeFields: includeFields,
        },
      }),
      providesTags: ['Devices'],
    }),
    getDeviceById: builder.query<
      GetDeviceApiResponse,
      {
        deviceId: number;
        includeFields?: GetDeviceOptionalFields[];
      }
    >({
      query: ({ deviceId, includeFields }) => ({
        url: `/v2/Devices/${deviceId}`,
        params: {
          IncludeFields: includeFields,
        },
      }),
      providesTags: ['Devices'],
    }),
    postMbusDevice: builder.mutation<
      PostMbusDeviceApiResponse,
      PostMbusDeviceApiArg
    >({
      query: (queryArg) => ({
        url: '/v2/Devices/Mbus',
        method: 'POST',
        body: queryArg.postMbusDeviceDto,
      }),
      invalidatesTags: ['Devices'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetDevicesByAccountQuery,
  useGetDeviceByIdQuery,
  usePostMbusDeviceMutation,
} = devicesApiSlice;
